import { render, staticRenderFns } from "./SubcampoFormComponent.vue?vue&type=template&id=225ea589"
import script from "./SubcampoFormComponent.vue?vue&type=script&lang=js"
export * from "./SubcampoFormComponent.vue?vue&type=script&lang=js"
import style0 from "./SubcampoFormComponent.vue?vue&type=style&index=0&id=225ea589&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports